import { Component } from '@angular/core';

@Component({
    selector: 'app-plans',
    templateUrl: './plans.component.html',
    styleUrl: './plans.component.scss',
    standalone: false
})
export class PlansComponent {

}
